import React, { Component } from "react";
import "../../Styles/Pages/datefilter.scss";
import Select from "./Select";
import DateRangeFilter from "./DateRangeFilter";
import Input from "./Input";
import { _validateNumber } from "../../Utils/helpers";
import dayjs from "dayjs";
import Portal from "../../Portal";
import Button from "./Button";

class DateFilter extends Component {
	constructor(props) {
		super(props);
		this.lastCountRef = React.createRef();
		this.state = {
			dateType: "-1",
			dateTypeOptions: [
				{ name: "All", value: "-1" },
				{ name: "Today", value: "1" },
				{ name: "Yesterday", value: "2" },
				{ name: "This month", value: "3" },
				{ name: "Last month", value: "4" },
				{
					name: "In the last",
					value: "5",
					hide: !!this.props.hideInTheLastSection,
				},
				{ name: "Custom date", value: "6" },
			],
			toDate: "",
			fromDate: "",
			lastTypeOptions: [
				{ name: "Days", value: "day" },
				{ name: "Weeks", value: "week" },
				{ name: "Months", value: "month" },
			],
			lastType: "day",
			lastCount: "30",
			dateResult: "",
			showModal: false,
		};
	}

	formatDate = date => {
		return dayjs(date).format("YYYY-MM-DD");
	};

	getDateResult = () => {
		let dateResult = "";
		const { dateType } = this.state;
		if (!["5", "6"].includes(dateType)) {
			if (dateType === "1") {
				dateResult = `${this.formatDate(
					dayjs().startOf("day"),
				)},${this.formatDate(dayjs().endOf("day"))}`;
			}
			if (dateType === "2") {
				dateResult = `${this.formatDate(
					dayjs().subtract(1, "day").startOf("day"),
				)},${this.formatDate(dayjs().subtract(1, "day").endOf("day"))}`;
			}
			if (dateType === "3") {
				dateResult = `${this.formatDate(
					dayjs().startOf("month"),
				)},${this.formatDate()}`;
			}
			if (dateType === "4") {
				dateResult = `${this.formatDate(
					dayjs().subtract(1, "months").startOf("month"),
				)},${this.formatDate(dayjs().subtract(1, "months").endOf("month"))}`;
			}
		}
		if (dateType === "5") {
			if (Number(this.state.lastCount)) {
				let lastCount = Number(this.state.lastCount);
				dateResult = `${this.formatDate(
					dayjs().subtract(lastCount - 1, this.state.lastType),
				)},${this.formatDate()}`;
			} else {
				dateResult = "";
			}
		}
		if (dateType === "6") {
			if (this.state.toDate || this.state.fromDate) {
				dateResult = `${this.state.fromDate || this.state.toDate},${
					this.state.toDate || this.state.fromDate
				}`;
			}
		}
		this.props.updateDate(dateResult, this.state);
	};

	initState = async () => {
		await this.setState(this.props.state);
	};

	focusLastCount = () => {
		if (this.state.dateType === "5") {
			if (this.lastCountRef.current) {
				this.lastCountRef.current.focus();
			}
		}
	};

	captureClick = () => {
		if (this.props.showModalFilter) {
			this.setState({ showModal: true });
		}
	};

	componentDidMount() {
		if (this.props.state) {
			this.initState();
		} else {
			if (this.props.dateType) {
				this.setState({ dateType: this.props.dateType.toString() }, () => {
					this.getDateResult();
				});
			}
		}
	}

	render() {
		return (
			<div className="custom-date-filter">
				{this.props.label && (
					<div className="form__label">{this.props.label}</div>
				)}
				<div className="custom-date-filter-select">
					<Select
						withMargin={true}
						options={this.state.dateTypeOptions.filter(el => !el.hide)}
						value={this.state.dateType}
						onClick={this.captureClick}
						onChange={e =>
							this.setState(
								{
									dateType: e.target.value,
									toDate: "",
									fromDate: "",
									lastCount: "",
									lastType: "day",
								},
								() => {
									this.focusLastCount();
									this.getDateResult();
								},
							)
						}
					/>
					{!this.props.showModalFilter && (
						<div className="custom-date-filter-select-section">
							{this.state.dateType === "6" && this.renderDateRange()}
							{this.state.dateType === "5" && this.renderInTheLastSection()}
						</div>
					)}
				</div>
				{this.state.showModal && ["5", "6"].includes(this.state.dateType) && (
					<Portal
						header={this.state.dateType === "5" ? "In the last" : "Custom Date"}
						closeModal={() => this.setState({ showModal: false })}
						width={this.state.dateType === "5" ? "400px" : ""}
						isSmall
					>
						<div style={{ paddingBottom: "70px" }}>
							{this.state.dateType === "6" && this.renderDateRange()}
							{this.state.dateType === "5" && this.renderInTheLastSection()}
						</div>
						<div className="modal-submit">
							<Button
								type={"outline"}
								text={"Update"}
								noMargin
								onClick={() =>
									this.setState({ showModal: false }, () => {
										this.getDateResult();
									})
								}
							/>
						</div>
					</Portal>
				)}
			</div>
		);
	}

	renderDateRange = () => {
		return (
			<DateRangeFilter
				from={this.state.fromDate}
				to={this.state.toDate}
				updateToDate={toDate =>
					this.setState({ toDate }, () => this.getDateResult())
				}
				updateFromDate={fromDate =>
					this.setState({ fromDate }, () => this.getDateResult())
				}
				withMargin={true}
				hideLabel={true}
				marginTop={"5px"}
				{...(this.props.autoScrollCalendar && { autoScroll: true })}
			/>
		);
	};

	renderInTheLastSection = () => {
		return (
			!this.props.hideInTheLastSection && (
				<div className="flex align-center">
					<div style={{ marginRight: "15px", maxWidth: "50px" }}>
						<Input
							size={"small"}
							value={this.state.lastCount}
							ref={this.lastCountRef}
							onChange={e =>
								this.setState({ lastCount: e.target.value }, () =>
									this.getDateResult(),
								)
							}
							onKeyPress={e => _validateNumber(e)}
							type={"text"}
							inputMode="numeric"
							pattern="\d*"
							maxLength={4}
							placeholder={5}
						/>
					</div>
					<div>
						<Select
							size={"small"}
							options={this.state.lastTypeOptions}
							value={this.state.lastType}
							onChange={e =>
								this.setState({ lastType: e.target.value }, () =>
									this.getDateResult(),
								)
							}
							width={"100px"}
						/>
					</div>
				</div>
			)
		);
	};
}

export default DateFilter;
